import React from "react";
import '../../css/home.css'

const Home = () => {
    return (
        <div className="home-page">
            <div className="home-wrapper">
                <div className="quote-container">
                    <h1>Your Mental Health Matters</h1>
                    <h2><em>You've got this.</em></h2>
                    <p>Find support, share your journey, and connect with others who understand</p>
                </div>
            </div>
        </div>
    )
}

export default Home;
